<!--
  画面名：-
  概要： 衛生管理計画書の差し替え・付則を行うコンポーネント
  備考： -
-->

<!-- HTML -->
<template>
  <!--  ページ全体を囲う要素  -->

  <div class="wrapper">
    <!-- 店舗マニュアル情報表示エリア -->
    <v-form
      ref="form"
      name="form"
      v-if="isOpen"
      style="height:100%"
    >
      <table>
        <tbody>
          <!-- 計画書PDF -->
          <tr>
            <td class="mb-5">
              <span class="titleManual">衛生管理計画書</span>
            </td>
            <td class="mb-5">
              <!-- データを表示 -->
              <v-container text-xs-center pa-0 class="input-file">
                <v-layout class="file-layout">
                  <!-- ファイル追加ボタン -->
                  <UploadButton
                    class="btn"
                    @file-update="setPlanPdf('replace', arguments[0])"
                    noTitleUpdate
                    :title="$language.LabelSelectFile"
                    color ="#2574a9"
                    small
                    :style="'padding-right:0px;border:0px;'"
                  />
                  <!-- 差し替え/雛形計画書名 -->
                  <span class="text">{{ strRplpdfName }}</span>
                </v-layout>
              </v-container>
              <!-- エラーメッセージ -->
              <div class="v-messages theme--light error--text" style="min-height:0px">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">
                    <!-- エラーメッセージが設定されていたら表示 -->
                    <span v-if="replaceMessage && replaceMessage.msg" style="white-space: pre-wrap">{{ replaceMessage.msg }}<!--
                      --><a v-if="replaceMessage.link" @click="replaceMessage.link()">{{ $language.MsgHere }}</a>
                    </span>
                  </div>
                </div>
              </div>
            </td>
            <!-- 差し替え衛生管理計画書PDFが登録されているとき -->
            <td style="text-align:right">
              <div style="display:flex;align-items: center;justify-content: space-between;">
                <!-- アイコンクリックにてPDFファイルを開く -->
                <div v-if="isShowPdf" style="height:22px;width:22px;" @click="openPdf('replace')">
                  <a><img src="@/assets/images/file-download.svg" /></a>
                </div>
                <!-- 削除ボタン -->
                <div v-if="!isDeleteReplace && !isTemplate" class='remove-button-area'>
                  <v-btn
                    class="icon-btn"
                    fab
                    small
                    color="#fff"
                    @click="deletePdf('replace')"
                  >
                    <v-icon color="#1f4e9c">remove</v-icon>
                  </v-btn>
                </div>
              </div>
            </td>
          </tr>
          <!-- 計画書PDF ここまで -->

          <!-- 計画書PDF付則 -->
          <tr>
            <td class="mb-5">
              <span class="titleManual">衛生管理計画書 付則</span>
            </td>
            <td class="mb-5">
              <!-- データを表示 -->
              <v-container text-xs-center pa-0 class="input-file">
                <v-layout class="file-layout">
                  <!-- ファイル選択ボタン -->
                  <UploadButton
                    class="btn"
                    @file-update="setPlanPdf('add', arguments[0])"
                    noTitleUpdate
                    :title="$language.LabelSelectFile"
                    color ="#2574a9"
                    small
                    :style="'padding-right:0px;border:0px;'"
                  />
                  <!-- 付則PDF名 -->
                  <span class="text">{{ strAddPdfName }}</span>
                </v-layout>
              </v-container>
              <!-- エラーメッセージ -->
              <div class="v-messages theme--light error--text" style="min-height:0px">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">
                    <!-- エラーメッセージが設定されていたら表示 -->
                    <span v-if="addedMessage && addedMessage.msg" style="white-space: pre-wrap">{{ addedMessage.msg }}<!--
                      --><a v-if="addedMessage.link" @click="addedMessage.link()">{{ $language.MsgHere }}</a>
                    </span>
                  </div>
                </div>
              </div>
            </td>
            <!-- ボタンエリア 付則が登録されているとき-->
            <td v-if="strAddPdfName" style="text-align:right">
              <div style="display:flex;align-items: center;justify-content: space-between;">
                <!-- アイコンクリックにてPDFファイルを開く -->
                <div v-if="isShowAdded" style="height:22px;width:22px;" @click="openPdf('add')">
                  <a><img src="@/assets/images/file-download.svg" /></a>
                </div>
                <!-- 削除ボタン -->
                <div v-if="!isDeleteAdded" class='remove-button-area'>
                  <v-btn class="icon-btn" fab small color="#fff" @click="deletePdf('add')">
                    <v-icon color="#1f4e9c">remove</v-icon>
                  </v-btn>
                </div>
              </div>
            </td>
          </tr>
          <!-- 計画書PDF付則 ここまで -->
        </tbody>
      </table>
    </v-form>
  </div>
</template>
<!-- /HTML -->

<script>
import UploadButton from 'vuetify-upload-button' // アップロードボタン

export default {
  props: {
    // 過去の計画書からコピーされてきたかどうか判定
    isCopy: { type: Boolean, default: false },
    // 計画書ID
    planId: Number,
    // 雛形タイトル
    templatePlanDocName: { type: String, default: '' },
    // 差し替え計画書タイトル
    replacePlanDocName: { type: String, default: '' },
    // 付則計画書タイトル
    addedPlanDocName: { type: String, default: '' }
  },
  // 子（外部）コンポーネント設定
  components: {
    UploadButton
  },
  // 初期値設定
  data () {
    return {
      // ダイアログ開かれているか判定する
      isOpen: false,
      // 付則用PDF
      isAddPdf: true,
      // 付則PDFにタイトル情報が含まれているか
      haveAddTitle: false,
      isDeleteManual: false,
      // 付則マニュアルの状態を格納
      isDeleteAddManual: false,
      // PDFチェックを格納
      isPdf: true,
      // PDFにタイトル情報が含まれているか
      haveTitle: false,
      planData: {},
      // 差し替えPDF名
      strRplpdfName: '',
      // 付則PDF名
      strAddPdfName: '',
      // 計画書の差し替えが行われているか判定するフラグ
      isTemplate: false,
      // ダイアログ画面で差し替えを行ったかどうか判定
      isReplaced: false,
      noXref: false,
      noXrefAdded: false,
      oldId: null,
      isShowPdf: false,
      isShowAdded: false,
      // 衛生管理計画書の削除状態
      isDeleteReplace: false,
      // 付則の削除状態
      isDeleteAdded: false,
      notSubmitReplace: false,
      notSubmitAdded: false,
      replaceMessage: {},
      addedMessage: {}
    }
  },
  methods: {
    // data初期化
    clearDisplay (kbn) {
      const clearReplace = () => {
        this.planData.replace = null // DB・S3登録用パラメータ
        this.strRplpdfName = '' // 衛生管理計画書の表示名
        this.replaceMessage = null // 差し替えPDF選択時のエラーメッセージ
        this.notSubmitReplace = false // 送信可否フラグ
      }
      const clearAdded = () => {
        this.planData.added = null // DB・S3登録用パラメータ
        this.strAddPdfName = '' // 衛生管理計画書 付則の表示名
        this.addedMessage = null // 付則PDF選択時のエラーメッセージ
        this.notSubmitAdded = false // 送信可否フラグ
      }
      if (kbn === 'replace') {
        // 差し替えを初期化
        clearReplace()
        // 差し替えを雛形に戻す
        this.strRplpdfName = this.templatePlanDocName
        this.isTemplate = true
      } else if (kbn === 'add') {
        // 付則を初期化
        clearAdded()
      } else {
        // 差し替えと付則を初期化
        clearReplace()
        clearAdded()
        // 削除状態の解除
        this.isDeleteReplace = false
        this.isDeleteAdded = false
        // 雛形フラグを切る
        this.isTemplate = false
        // ダイアログの表示状態
        this.isOpen = false
      }
    },
    // 差し替え/付則PDFの名前をセットする
    setPdfName () {
      this.isOpen = true
      // 衛生管理計画書PDFの参照ボタンを表示
      this.isShowPdf = true
      if (this.replacePlanDocName) {
        // 差し替えPDFを設定する
        this.strRplpdfName = this.replacePlanDocName
        this.planData.replace = { name: this.replacePlanDocName }
      } else {
        // 雛形を設定する
        this.strRplpdfName = this.templatePlanDocName
        this.isTemplate = true
      }
      // 付則
      if (this.addedPlanDocName) {
        // 衛生管理計画書 付則PDFの参照ボタンを表示
        this.isShowAdded = true
        this.strAddPdfName = this.addedPlanDocName
        this.planData.added = { name: this.addedPlanDocName }
      }
    },
    // PDFを参照
    openPdf (val) {
      let strComId = this.$store.getters['auth/getAuth'].businessCompanyId
      if (val === 'replace') {
        if (this.isTemplate) {
          window.open(process.env.VUE_APP_CLOUDCUBE_URL + '/public/template/planningDocument/' + 1 + '/planningDocument')
        } else {
          // 差し替え又は雛形PDFを参照する場合
          window.open(process.env.VUE_APP_CLOUDCUBE_URL + '/public/' + strComId + '/planningDocument/' + (this.isCopy ? this.oldId : this.planId) + '/planningDocument')
        }
      } else {
        // 付則PDFを参照する場合
        window.open(process.env.VUE_APP_CLOUDCUBE_URL + '/public/' + strComId + '/planningDocument/' + (this.isCopy ? this.oldId : this.planId) + '/addedPlanningDocument')
      }
    },
    // バリデーション処理
    validation (isEdit) {
      // 全体バリデーション
      if (this.$refs.form.validate() && this.isPdf) {
        if (isEdit) {
          return true
        }
        return false
      }
    },
    // ファイル読み込み処理
    setPlanPdf (val, file) {
      // ファイルを読み込まなかった場合は何もしない
      if (!file) return
      const self = this
      // データを設定する関数
      const setData = (fileName, dataUrl, errorMessage, noSubmit) => {
        if (val === 'replace') {
          // 削除状態を解除
          self.isDeleteReplace = false
          // ファイルの情報を設定
          self.strRplpdfName = fileName
          self.planData.replace = dataUrl ? {
            name: fileName,
            pdf: dataUrl
          } : null
          // PDF参照をできなくする
          self.isShowPdf = false
          // エラーメッセージを設定
          self.replaceMessage = errorMessage
          // 差し替えの送信可否フラグ
          self.notSubmitReplace = noSubmit
          // 雛形判定をfalseに変更
          self.isTemplate = false
        } else {
          // 削除状態を解除
          self.isDeleteAdded = false
          // ファイルの情報を設定
          self.strAddPdfName = fileName
          self.planData.added = dataUrl ? {
            name: fileName,
            pdf: dataUrl
          } : null
          // PDF参照をできなくする
          self.isShowAdded = false
          // エラーメッセージを設定
          self.addedMessage = errorMessage
          // 付則の送信可否フラグ
          self.notSubmitAdded = noSubmit
        }
      }
      const errorMessage = {}
      if (file.type === 'application/pdf') {
        // 読み込んだファイルがPDFの時
        const reader = new FileReader()
        file.text().then(value => {
          if (!/\r?\nxref\r?\n/.test(value)) {
            // ファイル読み込み中止
            reader.abort()
            errorMessage.msg = this.$language.MsgNoXref + '\n' + this.$language.MsgNoXrefHelp
            errorMessage.link = this.showHelp
            setData(file.name, null, errorMessage, true)
            return
          } else if (/<dc:title>|\/Title/.test(value)) {
            errorMessage.msg = this.$language.MsgHaveTitle + '\n' + this.$language.MsgHaveTitleHelpBefore
            errorMessage.link = this.showHelpTitle
          }
          // ファイル読み込み
          reader.readAsDataURL(file)
          // ファイル読み込み後の処理
          reader.addEventListener('load', function () {
            setData(file.name, reader.result, errorMessage)
          }, false)
        })
      } else {
        // 読み込んだファイルがPDF以外の時
        errorMessage.msg = this.$language.MsgNotPdf
        setData(file.name, null, errorMessage, true)
      }
    },
    // マニュアル削除
    deletePdf (val) {
      this.clearDisplay(val)
      if (val === 'replace') {
        // 差し替え計画書の削除
        this.isDeleteReplace = true
        // PDF参照を可能にする（雛形）
        this.isShowPdf = true
      } else {
        // 付則の削除
        this.isDeleteAdded = true
        // PDF参照をできなくする
        this.isShowAdded = false
      }
    },
    // 計画書を変換し保存する手順を表示
    showHelp () {
      window.open(process.env.VUE_APP_CLOUDCUBE_URL + '/public/help/howToPlanningExport.pdf')
    },
    showHelpTitle () {
      window.open(process.env.VUE_APP_CLOUDCUBE_URL + '/public/help/howToSaveWithoutTitle.pdf')
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/systemConfig/templateManual.scss';
</style>

<style lang="scss">
  @import '@/assets/scss/systemConfig/manualButton.scss';
</style>
